import { ChangeEvent, FC } from 'react';
import { Checkbox } from '@doda/io-react/common';
import classnames from 'classnames';
import { WardDrillDownType } from '../types';
import { DrillDownText } from '../../DrillDownText';
import styles from './index.module.scss';

/**
 * Propsの型定義
 * @param drillDown ドリルダウン
 * @param onChange チェックボックス更新処理
 */
interface Props {
  drillDown: Omit<WardDrillDownType, 'type'>;
  onChange: (event: ChangeEvent<HTMLInputElement>, selectedId: string) => void;
}

export const WardDrillDown: FC<Props> = ({ drillDown, onChange }) => {
  const { title, jobCount, url, prefecture } = drillDown;
  return (
    <div>
      <DrillDownText title={title} jobCount={jobCount} url={url} size="L" />
      <div className={classnames(styles.wardDrillDown, styles['-prefecture'])}>
        <DrillDownText
          title={prefecture.title}
          jobCount={prefecture.jobCount}
          url={prefecture.url}
          size="L"
        />
      </div>
      <div className={classnames(styles.wardDrillDown, styles['-city'])}>
        <DrillDownText
          title={prefecture.city.title}
          jobCount={prefecture.city.jobCount}
          url={prefecture.city.url}
          size="L"
        />
      </div>
      <ul>
        {prefecture.city.ward.map((ward) => (
          <li
            key={ward.id}
            className={classnames(styles.wardDrillDown, styles['-ward'])}
          >
            <Checkbox
              value={ward.id}
              checked={ward.isChecked}
              label={
                <DrillDownText
                  title={ward.title}
                  jobCount={ward.jobCount}
                  url={ward.url}
                  isBold={ward.isChecked}
                  size="L"
                />
              }
              onChange={(event) => {
                if (ward.isActiveOnChange) {
                  onChange(event, ward.id);
                }
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
